import { FiMail } from 'react-icons/fi'
import { Button } from '../../Component'
import contact_logo from '../../assets/Image/contact_logo.webp'
const Contact = () => {
    return (
        <>
            <div className="contact_main_Div">
                <div className='contact_icon_and_heading_div'>
                    <div className='solution_list_icon_div'>
                        <FiMail />
                    </div>
                    <div className='solution_list_text_div'>
                        <h4>HOW</h4>
                        <b>CAN WE HELP?</b>
                    </div>
                </div>
                <div className="contact_form_main">
                    <div className="contact_heading_div">
                        <h4>We’d love to hear about your project! Schedule a free discovery call to see how we can help or leave us a message.</h4>
                    </div>
                    <div className="form_main_div">
                        <div className="form_btn_div">
                            <Button title="SHEDULE A CALL" />
                        </div>
                        <div>
                            <img className='contact_logo' src={contact_logo} alt="" />
                        </div>
                        <div className="form_div">
                            <div className="inputs_main_div">
                                <div className="input_div">
                                    <p>Name</p>
                                    <input type="text" placeholder='Vitalik Buterin' />
                                </div>
                                <div className="input_div company_input_div">
                                    <p>Company</p>
                                    <input type="text" placeholder='Binance' />
                                </div>
                                <div className="input_div">
                                    <p>Email <span className='star'>*</span></p>
                                    <input type="email" placeholder='vitalik.buterin@binance.com' />
                                </div>
                            </div>
                            <div className="text_area_main">
                                <div className="text_area_div">
                                    <p>What are you building? <span className='star'> *</span></p>
                                    <textarea className='text_area' placeholder="I'm working on..." rows="4"></textarea>
                                </div>
                            </div>
                            <div className="inputs_main_div file_main_div">
                                <div className="file_div">
                                    <p>Please upload any relevant files (.pdf)</p>
                                    <input className='file' type="file" />
                                </div>
                            </div>
                            <div className="submit_btn_div">
                                <button>SUBMIT</button>
                            </div>
                        </div>
                        <p className='contact_form_div'>For career opportunities please send your application to careers@blockconsult.org</p>
                    </div>
                </div>
            </div>
        </>
    )
}
export default Contact